/**
 * 文件路径: frontend/shared/types/delivery.ts
 * 版本: v1.0 | 创建日期: 2026-02-25 | 创建人: AI
 *
 * 配送任务类型定义 - Phase 8 配送管理模块
 */

/** 配送任务状态枚举 */
export type DeliveryTaskStatus =
  | 'PENDING'
  | 'DEPARTED'
  | 'ARRIVED'
  | 'SUPPLEMENTED'
  | 'COMPLETED'
  | 'CANCELLED'

/** 配送任务状态中文映射 */
export const DELIVERY_TASK_STATUS_MAP: Record<DeliveryTaskStatus, string> = {
  PENDING: '待配送',
  DEPARTED: '已出发',
  ARRIVED: '已到达',
  SUPPLEMENTED: '已补货',
  COMPLETED: '已完成',
  CANCELLED: '已取消',
}

/** 配送任务状态标签颜色 */
export const DELIVERY_TASK_STATUS_TAG_TYPE: Record<DeliveryTaskStatus, string> = {
  PENDING: 'info',
  DEPARTED: 'warning',
  ARRIVED: 'primary',
  SUPPLEMENTED: '',
  COMPLETED: 'success',
  CANCELLED: 'danger',
}

/** 配送任务 ReadDTO */
export interface DeliveryTask {
  id: string
  // 业务维度
  enterprise: string
  enterprise_name: string | null
  workplace: string
  workplace_name: string | null
  restaurant: string
  restaurant_name: string | null
  meal_segment: string
  meal_segment_label: string | null
  service_date: string
  consumption_type: string
  consumption_type_label: string
  // 餐柜
  cabinet_type_label: string | null
  // 状态
  status: DeliveryTaskStatus
  status_label: string
  // 配送员
  delivery_person: string | null
  delivery_person_name: string
  delivery_person_phone: string
  // 时间节点
  created_at_issue: string | null
  expected_departure_at: string | null
  actual_departure_at: string | null
  expected_arrival_at: string | null
  actual_arrival_at: string | null
  supplement_arrival_at: string | null
  actual_completion_at: string | null
  // SLA
  is_late: boolean
  late_duration_minutes: number
  late_handling_status: string
  late_handling_notes: string
  // 订单统计
  order_count: number
  total_amount: string
  // 凭证
  delivery_proof_images: string[] | null
  supplement_proof_images: string[] | null
  // 元数据
  remarks: string
  created_at: string
  updated_at: string
}

/** 配送任务列表查询参数 */
export interface DeliveryTaskListParams {
  page?: number
  page_size?: number
  service_date?: string
  service_date_from?: string
  service_date_to?: string
  status?: DeliveryTaskStatus
  meal_segment?: string
  consumption_type?: string
  workplace?: string | number
  restaurant?: string | number
  enterprise?: string | number
  is_late?: boolean
  ordering?: string
}

/** 分配配送员请求 */
export interface AssignDeliveryPersonRequest {
  delivery_person_id?: number
  delivery_person_name: string
  delivery_person_phone: string
}

/** 上传凭证请求 */
export interface UploadProofRequest {
  images: string[]
  proof_type?: 'delivery' | 'supplement'
}

/** 迟到处理请求 */
export interface HandleLateRequest {
  status: 'HANDLED' | 'WAIVED'
  notes?: string
}
